
import axios_saranros from '../lib/axios-saranros';

class addressUsersCtrl {
    createAddressUser = (params) => {
        return new Promise(async (resolve, reject) => {
            try {
                const url = "api/AddressUsers";
                const result = await axios_saranros.post(url, { ...params });
                // Todo : when  save complete 
                resolve(result);
            }
            catch (err) {
                // Todo : save fail
                reject(err)
            }
        });
    }

    getAddressUsers = (params) => {
        return new Promise(async (resolve, reject) => {
            try {
                const filter = {
                    where: {
                        userId: params.userId
                    },
                    order: "no ASC"
                }
                const url = "api/AddressUsers?filter=" + JSON.stringify(filter);
                const result = await axios_saranros.get(url);
                // Todo : when  save complete 
                resolve(result);
            } catch (error) {
                reject(error)
            }
        });
    }
    updateAddressUser = (params) => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = {
                    no: params.no
                }
                const url = "api/AddressUsers/" + params.addressId;
                const result = await axios_saranros.patch(url, data);
                // Todo : when  save complete 
                resolve(result);
            } catch (error) {
                reject(error)
            }
        });
    }

    deleteAddressUser = (params) => {
        return new Promise(async (resolve, reject) => {
            try {
                const url = "api/AddressUsers/" + params.addressId;
                const result = await axios_saranros.delete(url);
                // Todo : when  save complete 
                resolve(result);
            } catch (error) {
                reject(error)
            }
        });
    }
}
export default addressUsersCtrl;